import Ajax from './ajax';

// 腾讯云
// export const cosInfos = () => Ajax.get(`/v1-cos`, null);//cos固定密钥
// export const cosInfos = () => Ajax.get(`/v1-temp-cos`, null);//cos临时密钥
// export const cosInfos = () => Ajax.get(`/v1-telecom-cos`, null, false);
export const cosInfos = () => Ajax.get(`/v1-get-oss`, null, false);
export const commonInfo = () => Ajax.get(`/v1-info`, null);
// 碎片内容
// export const getPatch = (data) => Ajax.get(`/v1-get-patch`, data);
export const getPatch = (data) => Ajax.get(`/fs-get-patch`, data);

export const studentPaSchool = (data) => Ajax.get(`/v1-student-pa-school`, data, false);  // 获取函授站
export const studentPaPro = (data) => Ajax.get(`/v1-student-pa-pro`, data, false);  // 获取专业

export const getVersion = (data) => Ajax.get(`/v1-get-version`, data);  // 获取版本号

export const useryear = (data) => Ajax.get(`/v1-adult-student-user-year`, data);  // 获取学年

export const verifyCode = (data) => Ajax.get(`/v1-get-verify-code`, data, false);  //获取验证码
